import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'hidden',
    ...theme.scrollbarStyles
  },
  tab: {
    borderBottom:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    '& .MuiTab-root': {
      minHeight: '28px',
      minWidth: '110px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.gray_100.main
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabScrollButton-root': {
      width: '25px'
    }
  },
  tabHeader: {
    // backgroundColor: theme.palette.blue_300.main,
    borderRadius: '8px 8px 0 0',
    margin: '12px 0px 0 0',
    padding: '2px 4px',
    position: 'relative',
    zIndex: 1,
    // boxShadow: '0 2px 5px rgba(0,0,0,0.1)',

    '&.Mui-selected': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      zIndex: 2,
      '& span': {
        color: theme.palette.white_100.main
      }
    }
  },
  customTableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  headerButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  headerButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '6px'
  },
  headerButtonsSwitch: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  buttonNewBot: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  },

  buttonActionEdit: {
    padding: '6px',
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    }
  },
  buttonActionDelete: {
    padding: '6px',
    borderRadius: 8,
    color: theme.palette.red_100.main,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },

  cardContainer: {
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRadius: '8px',
    padding: '16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  cardHeader: {
    minHeight: '80px',
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    padding: '8px 16px',
    margin: '-16px -16px 16px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderTop:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderLeft:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRight:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`
  },
  cardTitle: {
    fontWeight: '600',
    fontSize: '1rem'
  },
  cardContent: {
    flexGrow: 1,
    marginBottom: theme.spacing(2)
  },
  cardGreeting: {
    whiteSpace: 'pre-wrap'
  },
  cardOptions: {
    marginBottom: theme.spacing(2)
  },
  cardOptionsTitle: {
    color: theme.palette.blue_300.main,
    fontWeight: '600',
    fontSize: '1rem'
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'auto'
  },

  deleteButton: {
    backgroundColor: 'transparent',
    color: theme.palette.red_100.main,
    borderRadius: 8,
    padding: '6px',
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },
  optionsGrid: { padding: '2px !important', listStyle: 'none' },
  cardListOption: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  noOptionsText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  botContainer: {
    display: 'flex',
    gap: '8px',
    padding: '8px 16px'
  },
  botCardGrid: {
    display: 'flex',
    maxWidth: '200px'
  },
  botCardContainer: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    width: '100%',
    // maxWidth: '180px',
    // border:
    //   theme.palette.type === 'dark'
    //     ? '1px solid' + theme.palette.dark_stroke.main
    //     : '1px solid' + theme.palette.gray_stroke.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    borderRadius: '8px 0 0 8px',
    padding: '4px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '0',
    transition: 'all .2s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main,
      cursor: 'pointer',
      '& .MuiIconButton-root': {
        color: theme.palette.white_100.main
      }
    },
    '& .MuiIconButton-root': {
      transition: 'all .2s ease-in-out',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  botContainerEdit: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    borderRadius: '0 8px 8px 0',
    padding: '8px 6px',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    borderLeft:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_400.main
        : '1px solid' + theme.palette.gray_stroke.main,
    '& .MuiIconButton-root': {
      backgroundColor: 'transparent',
      transition: 'all .2s ease-in-out',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      height: '100%'
    },
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main,
      cursor: 'pointer',
      '& .MuiIconButton-root': {
        color: theme.palette.white_100.main
      }
    }
  },
  botCardContainerActive: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    '& .MuiIconButton-root': {
      color: theme.palette.white_100.main
    }
  },
  botCardHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  botHeaderTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  botCardTitle: {
    fontSize: '1rem',
    fontWeight: '600'
  },
  botCardContent: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  botWhatsAppNumber: {
    fontSize: '.875rem'
  },
  departmentContainer: {
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    width: 'calc(100% - 32px)',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '6px',
    margin: '10px 16px 0 16px',
    borderRadius: '8px'
  },
  departmentButtons: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center'
  },

  departmentCardGrid: {
    display: 'flex'
  },
  departmentCardContent: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    borderRadius: '8px 0 0 8px',
    padding: '4px 8px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all .2s ease-in-out',
    cursor: 'pointer', // Remove a borda para ficar alinhado ao botContainerEdit
    borderRight: 'none',
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main
    }
  },
  departmentCardContentActive: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main
  },

  departmentContainerEdit: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    borderRadius: '0 8px 8px 0',
    padding: '4px',
    // height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', // Centraliza verticalmente o ícone
    height: 'auto', // Ajusta a altura
    borderLeft:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_400.main
        : '1px solid' + theme.palette.gray_stroke.main,
    '& .MuiIconButton-root': {
      backgroundColor: 'transparent',
      transition: 'all .2s ease-in-out',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main, // Cor do ícone
      height: '100%'
    },
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      cursor: 'pointer',
      '& .MuiIconButton-root': {
        color: theme.palette.white_100.main // Cor do ícone no hover
      }
    }
  },

  buttonDepartment: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: '8px',
    boxShadow: 'none',
    height: '25px',
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main,
      boxShadow: 'none'
    },
    border: '1px solid red'
  },
  buttonDepartmentActive: {
    // NOVO ESTILO
    backgroundColor: theme.palette.green_200.main, // Cor verde para ativo
    color: theme.palette.white_100.main,
    '&:hover': {
      backgroundColor: theme.palette.green_200.main
    }
  },

  nameDepartment: {
    fontSize: '1rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& span': {
      fontWeight: '600',
      color: theme.palette.blue_300.main,
      marginLeft: '8px'
    }
  },

  '@global': {
    '.react-flow__attribution': {
      display: 'none !important'
    }
  }
}))
